(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["swagger-ui-standalone-preset"] = factory();
	else
		root["swagger-ui-standalone-preset"] = factory();
})(this, () => {
return 